document.addEventListener("DOMContentLoaded", () => {
  const addItemBtn = document.getElementById("deliveries-add-item");
  const itemsTable = document.querySelector("#deliveries-items-table-body");
  const orderTotalDisplay = document.getElementById("deliveries-order-total");
  const itemTemplate = document.getElementById("deliveries-item-template");

  function recalcRowTotal(row) {
    const valueField = row.querySelector(".deliveries-value");
    const qtyField = row.querySelector(".deliveries-qty");
    const rowTotalField = row.querySelector(".deliveries-row-total");

    const value = parseFloat(valueField?.value) || 0;
    const qty = parseFloat(qtyField?.value) || 0;
    const total = value * qty;

    if (rowTotalField) rowTotalField.value = total.toFixed(2);
  }

  function recalcOrderTotal() {
    let sum = 0;
    itemsTable.querySelectorAll(".deliveries-item-row").forEach(row => {
      const destroyFlag = row.querySelector(".deliveries-destroy-flag");
      if (!destroyFlag || destroyFlag.value !== "1") {
        const rowTotalField = row.querySelector(".deliveries-row-total");
        sum += parseFloat(rowTotalField?.value) || 0;
      }
    });
    if (orderTotalDisplay) orderTotalDisplay.textContent = sum.toFixed(2);
  }

  if (addItemBtn) {
    addItemBtn.addEventListener("click", () => {
      if (!itemTemplate) return;

      const newRowHtml = itemTemplate.innerHTML;
      const uniqueIndex = new Date().getTime();
      const rowHtml = newRowHtml.replace(/NEW_RECORD/g, uniqueIndex);

      const tempDiv = document.createElement("tbody");
      tempDiv.innerHTML = rowHtml.trim();
      const newRow = tempDiv.firstElementChild;

      newRow.querySelectorAll("input").forEach(input => {
        if (input.type === "text" || input.type === "number") input.value = "";
        if (input.classList.contains("deliveries-destroy-flag")) input.value = "0";
      });

      itemsTable.appendChild(newRow);
    });
  }

  if (itemsTable) {
    itemsTable.addEventListener("click", (e) => {
      const removeLink = e.target.closest(".deliveries-remove-item");
      if (removeLink) {
        const row = removeLink.closest("tr");
        const destroyFlag = row.querySelector(".deliveries-destroy-flag");
        if (destroyFlag) {
          destroyFlag.value = "1";
          row.style.display = "none";
        } else {
          row.remove();
        }
        recalcOrderTotal();
      }
    });

    itemsTable.addEventListener("input", (e) => {
      const row = e.target.closest("tr");
      if (row && (e.target.classList.contains("deliveries-value") || e.target.classList.contains("deliveries-qty"))) {
        recalcRowTotal(row);
        recalcOrderTotal();
      }
    });

    itemsTable.querySelectorAll(".deliveries-item-row").forEach(row => recalcRowTotal(row));
    recalcOrderTotal();
  }
});
